import React, { Component } from 'react';
import { bool, func, number, object, string } from 'prop-types';
import { connect } from 'react-redux';
import { noop } from 'lodash';
import classNames from 'classnames';
import { I18nProvider } from '@fiverr-private/fiverr_context';
import { isVoiceOver } from '../../../../utils/packagesUtils';
import { getLabel } from '../../../../utils/translation/pricingFactors/label';
import { getBuyerTooltip } from '../../../../utils/translation/pricingFactors/buyerTooltip';
import { CUSTOM_EXTRA_TYPE, EXTRA_FAST_TYPE, FEATURE_TYPE } from '../../../../utils/packagesUtils/constants';
import { PackageExtraCheckbox } from '../PackageExtraCheckbox';
import Quantity from '../../Quantity';
import { updateCustomExtra, updateExtraFast, updateFeature, updateVoData } from '../../../../actions/packages';
import { getPackageById, getSingleCalculator } from '../../../../reducers/packages';
import calculateVoData from '../../../../utils/voiceOver';

import './style.scss';

class PackageExtra extends Component {

    constructor(props) {
        super(props);

        this.onCheckboxChange = this.onCheckboxChange.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    onCheckboxChange({ target }) {
        this.onChange(target.checked ? 1 : 0);
    }

    onChange(amount) {
        const { type, id, packageId, onExtraChange, updateVoData } = this.props;
        const { general } = this.context;

        onExtraChange({
            type,
            id,
            packageId,
            amount
        });

        if (isVoiceOver(general)) {
            updateVoData({ packageId });
        }
    }

    isChecked() {
        const { amount } = this.props;

        return amount >= 1;
    }

    calculateLabel(i18n) {
        const { name, label } = this.props;
        const { subCategoryId } = this.context.general;

        return this.shouldTranslateExtra()
            ? getLabel({ i18n, name, subCategoryId })
            : label;
    }

    calculateBuyerTooltip(i18n) {
        const { name, buyerTooltip } = this.props;
        const { subCategoryId } = this.context.general;

        return this.shouldTranslateExtra()
            ? getBuyerTooltip({ i18n, name, subCategoryId })
            : buyerTooltip;
    }

    shouldTranslateExtra() {
        const { type } = this.props;
        return type === FEATURE_TYPE;
    }

    render() {
        const {
            label,
            currentPrice,
            amount,
            currentDuration,
            hasQuantity
        } = this.props;

        const { currencyConverter } = this.context;

        if (!currentPrice || !label) {
            return null;
        }

        const checked = this.isChecked();

        return (
            <li className={classNames({ checked })}>
                {

                    // This div is needed because in the single package component we have different
                    // padding for it and since we're using a transition on max-height we don't want
                    // the padding to be part of the transition
                }
                <div className="package-extra">
                    <I18nProvider>
                        {({ i18n }) => (<>
                            <PackageExtraCheckbox checked={checked}
                                label={this.calculateLabel(i18n)}
                                tooltipContent={this.calculateBuyerTooltip(i18n)}
                                onChange={this.onCheckboxChange}
                                currentDuration={currentDuration}/>
                            {hasQuantity ?
                                <Quantity quantity={amount || 1} price={currentPrice} onQuantityChange={this.onChange}/> :
                                <p>{currencyConverter.convert(currentPrice)}</p>
                            }

                        </>)}
                    </I18nProvider>
                </div>
            </li>
        );
    }
}

PackageExtra.propTypes = {
    id: number,
    name: string,
    label: string,
    buyerTooltip: string,
    currentPrice: number,
    amount: number,
    onExtraChange: func,
    updateVoData: func,
    currentDuration: number,
    hasQuantity: bool,
    type: string,
    packageId: number
};

PackageExtra.defaultProps = {
    onExtraChange: noop,
    updateVoData: noop,
    hasQuantity: true
};

PackageExtra.contextTypes = {
    currencyConverter: object,
    general: object,
    logger: object
};

const onExtraChange = ({ type, id, packageId, amount }) => (dispatch) => {
    switch (type) {
        case FEATURE_TYPE:
            dispatch(updateFeature({ featureId: id, amount }));
            break;
        case CUSTOM_EXTRA_TYPE:
            dispatch(updateCustomExtra({ customExtraId: id, amount }));
            break;
        case EXTRA_FAST_TYPE:
            dispatch(updateExtraFast({ value: amount, packageId }));
            break;
        default:
            break;
    }
};

const dispatchUpdateVoData = ({ packageId }) => (dispatch, getState) => {
    const { packages } = getState();
    const packageData = getPackageById(packages, packageId);
    const calculator = getSingleCalculator(packages, packageId);
    if (!calculator) {
        return;
    }
    const { id, currentValue } = calculator;
    const voData = calculateVoData({ scriptLength: currentValue, calculatorId: id, packageData });
    dispatch(updateVoData({ voData }));
};

export { PackageExtra };

export default connect(
    null,
    {
        onExtraChange,
        updateVoData: dispatchUpdateVoData
    }
)(PackageExtra);
